import Character from "@lss/common/src/shell/Character";




interface StrangerFemaleINT {
}

const strangerFemaleProperties: StrangerFemaleINT = {
}

const strangerFemale = new Character<StrangerFemaleINT>( "Stranger", strangerFemaleProperties, "#FF63C7FF");

export {
    strangerFemale,
}